<template>
    <BaseDialog
        v-model="is_open"
        class="fs-dialog-confirm"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <el-row>
				<el-col class="box-dialog">
					<img :src="require('@/assets/'+dialogSrc)" width="45%">
					<b class="dialog-title my-2" v-html="dialogTitle"></b>
					<span class="text-heading3" v-html="dialogText"></span>
				</el-col>
				<el-col class="my-2">
					<el-row v-if="dialogConfirm && dialogRedirect.length > 0">
                        <!-- Left Button -->
						<!-- <el-col :span="12" v-if="dialogRedirect[1] == 'overdistance'">
							<el-button class="fs-btn-border" @click="changeOrderType()">รับเองที่สาขา</el-button>
						</el-col> -->
                        <el-col :span="12">
							<el-button class="fs-btn-border text-button" @click="is_open = false">{{ $t('dialog.close') }}</el-button>
						</el-col>
                        <!-- Right Button -->
                        <el-col :span="12" v-if="dialogRedirect[1] == 'overdistance'">
							<el-button class="fs-confirm text-button" @click="toggleMapDrawer()">{{btnText}}</el-button>
						</el-col>
						<el-col :span="12" v-else>
							<el-button class="fs-confirm text-button" @click="redirectPage(dialogRedirect[1])">{{btnText}}</el-button>
						</el-col>
					</el-row>
					<el-row v-else>
						<el-col>
							<el-button class="fs-confirm text-button" @click="is_open = false">{{btnText}}</el-button>
						</el-col>
					</el-row>
				</el-col>
      </el-row>
    </BaseDialog>
</template>

<script>
export default {
    props:{
        dialogTitle: {
            default: ""
        },
        dialogText: {
            default: ""
        },
        dialogSrc: {
            default: ""
        },
        btnText: {
            default: ""
		},
        dialogConfirm: {
            default: false
        },
        dialogRedirect: {
            default: []
        }
    },
    data() {
        return {
            is_open: true
        }
		},
		methods: {
			redirectPage (path) {
				this.$router.push(path)
            },
            toggleMapDrawer () {
                this.is_open = false
                this.$emit('toggleDialog', 'ismap')
            }
            // changeOrderType () {
            //     this.is_open = false
            //     this.$emit('toggleDialog', 'pickup')
            // }
		},
    watch: {
        is_open(value) {
            this.$emit('toggleDialog', null)
        }
    }
}
</script>

<style scoped>
.box-dialog {
    width: 100%;
    text-align: center;
}
.box-dialog .dialog-title {
    display: block;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    /* line-height: 35px; */
    /* margin-top: 1rem; */
    text-align: center;
    letter-spacing: 0px;
    color: #262628;
}
#dialog-component .el-dialog__header {
    display: none;
}
#dialog-component .el-dialog--center .el-dialog__body {
    padding-top: 44px;
}
.btn-ok.el-button {
    background: #28B7FF;
    border-radius: 9px;
    width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    /* or 162% */

    text-align: center;
    letter-spacing: 0.341333px;

    color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/Dialog.vue